import React, { memo } from 'react';
import {
  ChartComponent,
  SeriesCollectionDirective,
  Inject,
  Legend,
  Category,
  DateTime,
  DataLabel,
  Highlight,
  Tooltip,
  ColumnSeries,
  LineSeries,
} from '@syncfusion/ej2-react-charts';
import PropTypes from 'prop-types';
import { chartTypes } from '../utils/constants';

const BarChartComponent = ({ chartResult, chartPalette, renderSeries, generateAxis, jobId, chartType }) => {
  const { primaryXAxis, primaryYAxis, axes = [] } = generateAxis({ chartType });
  const { queryConstruct } = chartResult?.query || {};
  const qcChart = queryConstruct.chart;

  return (
    <ChartComponent
      id={`chart-${jobId}`}
      width="100%"
      height="100%"
      style={{ textAlign: 'center' }}
      legendSettings={
        qcChart?.format.legend
          ? {
              visible: true,
              enableHighlight: true,
              textWrap: 'Wrap',
              position: 'Bottom',
              alignment: 'Near',
              containerPadding: { top: 20 },
              itemPadding: 0,
              padding: 10,
            }
          : {}
      }
      primaryXAxis={primaryXAxis}
      primaryYAxis={primaryYAxis}
      axes={axes}
      chartArea={{ border: { width: 0 } }}
      tooltip={{ enable: true }}
      palettes={chartPalette}>
      <Inject services={[ColumnSeries, LineSeries, Legend, Tooltip, Category, DateTime, DataLabel, Highlight]} />
      <SeriesCollectionDirective>
        {chartResult?.queryResult?.map((series, i) => {
          let type;
          switch (qcChart?.format?.seriesFormats[i]?.type) {
            case chartTypes.BAR_CHART:
              type = 'Column';
              break;
            case chartTypes.STACKED_BAR_CHART:
              type = 'StackingColumn';
              break;
            case chartTypes.STACKED_BAR_100_CHART:
              type = 'StackingColumn100';
              break;
            case chartTypes.HORIZONTAL_BAR_CHART:
              type = 'Bar';
              break;
            case chartTypes.STACKED_LINE_CHART:
              type = 'StackingLine';
              break;
            case chartTypes.LINE_CHART:
              type = 'Line';
              break;
            case chartTypes.AREA_CHART:
              type = 'Line';
              break;
            case chartTypes.SCATTER_PLOT:
              type = 'Scatter';
              break;
            default:
              type = 'Column';
              break;
          }

          return renderSeries({ series, type: type, index: i, qcChart });
        })}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

BarChartComponent.propTypes = {
  data: PropTypes.object,
  renderSeries: PropTypes.func.isRequired,
  chartPalette: PropTypes.array.isRequired,
  generateAxis: PropTypes.func.isRequired,
  chartResult: PropTypes.object,
  jobId: PropTypes.string.isRequired,
  chartType: PropTypes.string.isRequired,
};

export default memo(BarChartComponent);
